export default __webpack_public_path__ + "static/media/favorite-normal.bddf0069.svg";